import API from "@lib/axiosConfig";

export default (url, id) => API.delete(`${url}/${id}`);
